export const locale = {
    lang: 'zh1',
    data: {
      'LOGIN': {
        'AUTENTICACION': {
          'TITULO': '兩步驗證',
          'SUBTITULO': '為了在進入平台時提供更高的安全性，您需要執行如下所示的兩步驗證',
          'BOTONES': {
            'SIGUIENTE': '下一個',
            'ANTERIOR': '以前的'
          },
          'PASOS': {
            '1': {
              'TITULO': '步驟1',
              'INSTRUCCION': '使用 Google Authenticator 移動應用掃描二維碼，然後單擊下一步按鈕',
              'REGISTRADO': '檢測到您的郵箱已經在谷歌身份驗證器應用中註冊，無需再次掃描二維碼，繼續下一步'
            },
            '2': {
              'TITULO': '第2步',
              'INSTRUCCION': '輸入 Google Authenticator 提供的密鑰，然後單擊下一步 ',
              'INPUT': '獲得的鑰匙',
              'INFOPREVIA': {
                'INFO_1': '檢測到您已經從這台電腦訪問過平台。 無需再次掃描二維碼',
                'INFO_2': '只需輸入 Google Authenticator 為您的帳戶提供的密碼，然後單擊下一步',
                'INFO_3': '如果要再次掃描二維碼，請單擊“上一步”按鈕',
                'INFO_4': '警告：這樣做，您將不得不再次將您的帳戶鏈接到 Google 身份驗證器',
              }
            },
            '3': {
              'TITULO': '結果',
              'INSTRUCCION': '輸入上一步從二維碼中獲取的密鑰，然後單擊下一步按鈕',
              'VALIDANDO': '驗證輸入的密鑰，稍等片刻',
              'MAL': '密鑰不正確或已過期，請重新輸入密鑰並重試',
              'BIEN': '您已成功完成認證，然後您將進入平台'
            },
          }
        },
        'PASSWORD':{
          'AVISO':'請輸入您的電子郵件地址，我們將發送給您更改密碼的鏈接',
          'BTN':'發送電子郵件',
          'PLACERHOLDER':'電子郵件地址',
          'ERROR':'我們找不到您的電子郵件。請嘗試其他電子郵件',
          'TRUE':'電子郵件已發送，請檢查您的收件箱或垃圾郵件文件夾'
        },
        'RESET':{
          'LABEL01':'請...輸入用戶的新密碼：   ',
          'LABEL02':'密碼',
          'LABEL03':'重新輸入密碼',
          'BTN':'更改密碼',
          'ERROR':'錯誤，找不到令牌',
          'NOPASSWORDMATCH':'密碼不匹配',
          'CARACTERES':'必須至少3個字',
          'SUCCESSCHANGE':'您的密碼已正確更改'
        },
        'LANDING': {
          'MENSAJE': '歡迎',
          'NAVEG': '建議使用<a class="linkChrome" href="https://www.google.com/intl/es-419/chrome/" target="blank"> Google Chrome </a>瀏覽器'
        },
        'MODALES': {
          'AVISO1': {
            'TITULO': '重要公告。',
            'TEXTO': `尊敬的用戶：<br><br>
             通知您，為了提供更好的服務，文化GO平台將進行更新以優化其運營。<br><br>
             更新將於 <strong>7 月 23 日星期五晚上 11:59 開始。 直到晚上 11:59 7 月 24 日星期六</strong>。 在此期間，平台將保持不活動狀態。 但是，當前的調查將保持有效。<br><br>`
          }
        },
        'FORM': {
          'FORGOTPASSWORD':'找回密碼',
          'TITULO': '登錄您的帳戶',
          'INPUT':{
            'EMAIL': '電子郵件',
            'PASSWORD': '密碼',
            'LANGSEL': '選擇語言'
          },
          'VAL': {
            'NOTEMAIL': '電子郵件為必填',
            'INVEMAIL': '請輸入有效的電郵地址',
            'CARACT_EMA': ' 字段不允許以下字符 /&¿+#$%([=])*?"<>:\'',
            // 'PASS': '密碼為必填',
            'PASS': '無效密碼',
          },
          'SIGNIN': '進入!',
          'CAMBIALOGO': '點擊此處更改您的公司徽標',
          'CARGAOK': '您的公司徽標已正確加載',
          'CARGANULL': '加載您的公司徽標時出錯',
          'CARGAERROR': '所選文件的格式不正確。 僅接受格式:jpg，png，gif'
        }
      },
      'LOGIN-ENCUESTADOR':{
        'FORM': {
          'TITULO': 'INGRESE A SU CUENTA',
          'INPUT':{
            'PASSWORD': '密碼:',
            'LANGSEL': '選擇一種語言',
            'LOGIN':'登錄',
          },

      },
      'INTRO-LOGIN':{
        'TITULO':'使用說明',
        'TEXT1':'工作場所®學院。歡迎您100％保密地回答您的工作環境調查',
        'TEXT2':'機密性',
        'TEXT3':'在研究所:',
        'TEXT4':'我們按組織和領域管理,處理,統計分析響應。',
        'TEXT5':'我們產生了表明組織環境中改進措施的全球結果。',
        'TEXT6':'您不知道個人的回答',
        'TEXT7':'個人回复嚴格保密,',
        'TEXT8':'投訴和建議',
         'TEXT9':'嚴格禁止:',
         'TEXT10':'您以任何方式受到影響,受到懲罰或受到阻止,無法自由回答調查。',
         'TEXT11':'我們向您發送以下電子郵件,以提出投訴或建議:',
         'TEXT12':'mx_transparencia@greatplacetowork.com',
         'TEXT13':'說明:',
         'TEXT14':'1。輸入您的 ',
         'TEXT15':'僱員編號+出生年份。',
         'TEXT16':'2。請勿留空格。',
         'TEXT17':'3。單擊開始',
         'TEXT18':'幫助我們回答“工作場所®學院”調查！！',
      }

    },
    'LOADING':{
      'TEXT_WELCOM':'歡迎來到CulturalGo',
       'TEXT_CHANGE':'正在加載信息...',
    }
    }
};
